<template>
  <v-container>
    <v-img
      :src="logoUrl"
      class="logo"
      position="left top"
    />
    <WelcomeContent />
  </v-container>
</template>

<script>
import logoUrl from '@/assets/cul_colour.png'
import WelcomeContent from '@/components/WelcomePage.vue'

export default {
  components: {
    WelcomeContent,
  },
  data: () => ({
    dialog: false,
    logoUrl,
  }),
}
</script>

<style>
.logo { margin-bottom: 20px; max-height: 50px; }
</style>
